import { useContext, useEffect, useState } from "react";
import DeleteIcon from "../../../../../../../../utils/Images/AddSource/DeleteIcon";
import SettingIcon from "../../../../../../../../utils/Images/AddSource/SettingIcon";

import "./SourceList.scss";
import PlusIcon from "../../../../../../../../utils/Images/PlusIcon";
import {
  AssessmentButton,
  CheckboxRadio,
  InputField,
  showToast,
  SourceCard,
} from "ui-components";
import CustomModal from "../../../../../../../../components/CustomModal/CustomModal";
import {
  capitalizeFirstLetter,
  convertDate,
  redirectTo,
  setInQueryParams,
} from "../../../../../../../../utils/Common/Constant";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EvluateShortIcon from "../../../../../../../../utils/Images/EvluateShortIcon";
import RefreshIconBorderLess from "../../../../../../../../utils/Images/RefreshIconBorderLess";
import WarningTriangle from "../../../../../../../../utils/Images/WarningTriangle";
import {
  addSource,
  deleteSource,
  getSourcesList,
  refreshJobIntegration,
} from "../../../../../../../../service/CvScanning/CvScanning";
import Loader from "../../../../../../../../components/Loader/Loader";
import { systemPreferenceContext } from "../../../../../../../../context/SystemPreference/SystemPreference";
import getRefreshToken from "../GmailAuth";
import { JobScreensEnums } from "../../../../../../../../utils/Enums/JobScreensEnums";
import CircleCrossIcon from "../../../../../../../../utils/Images/CircleCrossIcon";
import SourceSelectTick from "../../../../../../../../utils/Images/SourceSelectTick";
const SourceList = ({ getCVCounts, sourcesListApi }: any) => {
  const [sourceList, setSourceList] = useState<any>([]);
  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isOpenAddSource, setIsOpenAddSource] = useState(
    searchParams.get("isOpenAddSource") === "true" || false,
  );
  const [sourceData, setSourceData] = useState<any>([]);
  const [selectedSource, setSelectedSource] = useState<any>(null);
  const [selectedSourceCard, setSelectedSourceCard] = useState<any>({});
  const [updateSourceList, setUpdateSourceList] = useState(0);
  const [addSourceLoading, setAddSourceLoading] = useState(false);
  const [sourceRefreshing, setSourceRefreshing] = useState<number | null>(null);
  const { preferenceData } = useContext(systemPreferenceContext);
  const { t } = useTranslation();
  const [flippedIndex, setFlippedIndex] = useState(null);
  const [aliasInputText, setAliasInputText] = useState("");
  const [privacyCheck, setPrivacyCheck] = useState(false);
  const handleSourceClick = (item: number) => {
    setSelectedSource(item);
    setAliasInputText("");
    setPrivacyCheck(false);
  };
  const { jobId } = useParams();
  const addSourceApi = async (addSourceData: any) => {
    setAddSourceLoading(true);
    try {
      const res = await addSource(addSourceData);
      if (res?.status === 200) {
        showToast(res?.customMessage, "success");
        setInQueryParams(queryParams, "isOpenAddSource", false, navigate);
        setIsOpenAddSource(false);
        setUpdateSourceList(Math.random() * 10);
        setAddSourceLoading(false);
        getCVCounts();
        sourcesListApi();
        setAliasInputText("");
        setPrivacyCheck(false);
        setSelectedSource(null);
      } else {
        setAddSourceLoading(false);
      }
    } catch (error) {
      setAddSourceLoading(false);
      console.error(error);
    }
  };
  // Add source card Api
  const handleAddSource = async () => {
    if (
      selectedSource?.label === "Gmail" ||
      selectedSource?.label === "email"
    ) {
      const response: any = await getRefreshToken();
      if (!response?.error) {
        const splitUrl = selectedSource?.icon?.split(".net/");
        const trimIconUrl = splitUrl?.length > 1 ? `${splitUrl[1]}` : "";
        const addSourceData = {
          jobId: jobId,
          type: "email",
          meta: {
            access_token: response?.tokenData?.access_token,
            expires_in: response?.tokenData?.expires_in,
            refresh_token: response?.tokenData?.refresh_token,
            scope: response?.tokenData?.scope,
            token_type: response?.tokenData?.token_type,
          },
          name: aliasInputText,
          provider: "Gmail",
          sourceIcon: trimIconUrl,
          emailId: response?.userInfo?.email,
        };
        addSourceApi(addSourceData);
      } else {
        showToast(t("RESUME.TRY_AGAIN"));
      }
    } else if (selectedSource?.label === JobScreensEnums.LABEL_EVLUATE) {
      const splitUrl = selectedSource?.icon?.split("net/");
      const trimIconUrl = splitUrl?.length > 1 ? `${splitUrl[1]}` : "";
      const addSourceData = {
        jobId: jobId,
        type: JobScreensEnums.TYPE_DATABASE,
        meta: null,
        name: JobScreensEnums.TYPE_DATABASE,
        provider: null,
        sourceIcon: trimIconUrl,
        emailId: null,
      };
      addSourceApi(addSourceData);
    } else {
      showToast(t("RESUME.ASSESSMENT_COMING_SOON"));
    }
  };
  useEffect(() => {
    if (preferenceData?.jobSources) {
      const result = Object.keys(preferenceData?.jobSources).map(
        (key, index) => ({
          id: index,
          label: key,
          icon: preferenceData?.jobSources[key],
        }),
      );
      const sortedData = [
        ...result.filter(
          (item) => item.label === JobScreensEnums.LABEL_EVLUATE,
        ),
        ...result.filter(
          (item) => item.label !== JobScreensEnums.LABEL_EVLUATE,
        ),
      ];
      setSourceData(sortedData);
    }
  }, [preferenceData]);
  const getSourcesListApi = async () => {
    try {
      const res = await getSourcesList(jobId);
      const sourceList = res?.data?.data || [];
      const sortedSourceList = [
        ...sourceList.filter(
          (item: any) => item.type === JobScreensEnums.TYPE_DATABASE,
        ),
        ...sourceList.filter(
          (item: any) => item.type !== JobScreensEnums.TYPE_DATABASE,
        ),
      ];
      setSourceList(sortedSourceList);
    } catch (error) {
      console.error(error);
    }
  };

  // refresh job integration api
  const refreshJobIntegrationApi = async (item: any, index: any) => {
    setSourceRefreshing(index);
    try {
      const res = await refreshJobIntegration(jobId, item?.jobIntegrationId);
      if (res?.status === 200) {
        setSourceRefreshing(null);
        if (res?.data?.cvAdded === 0) {
          showToast(t("GENERAL.NO_NEW_CV"));
        } else {
          showToast(
            `${res?.data?.cvAdded} ${t("GENERAL.NEW_CV_MESSAGE_1")}`,
            "success",
          );
          getCVCounts();
        }
        setUpdateSourceList(Math.random() * 10);
      } else {
        setSourceRefreshing(null);
      }
    } catch (error) {
      console.error(error);
      setSourceRefreshing(null);
    }
  };
  useEffect(() => {
    getSourcesListApi();
  }, [updateSourceList]);
  const confirmDeleteSource = async () => {
    try {
      const res = await deleteSource(
        jobId,
        selectedSourceCard?.jobIntegrationId,
      );
      if (res?.status === 200) {
        setFlippedIndex(null);
        showToast(res?.customMessage, "success");
        setUpdateSourceList(Math.random() * 10);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleDeletePress = (item: any, ind: any) => {
    setSelectedSourceCard(item);
    setFlippedIndex(ind === flippedIndex ? null : ind); // Toggle flip state for the card
  };
  // condition to show database source disabled when already present
  const isDataTypePresent = sourceList?.some(
    (item: any) => item?.type === JobScreensEnums.TYPE_DATABASE,
  );

  return (
    <div className="sourceList">
      <div
        onClick={() => {
          setIsOpenAddSource(true);
          setInQueryParams(queryParams, "isOpenAddSource", true, navigate);
        }}
        className="subSource"
      >
        <PlusIcon color={"var(--light-grey)"} />
        <span>{t("RESUME.ADD_SOURCE")}</span>
      </div>
      {sourceList?.map((item: any, ind: number) => {
        return (
          <div key={ind}>
            {item?.type === JobScreensEnums.TYPE_DATABASE ? (
              <SourceCard
                index={0}
                label={t("GENERAL.PROJECT_NAME")}
                icon={<EvluateShortIcon />}
                email={t("RESUME.SCAN_EXISTING_DATABASE")}
                className={"databaseSourceCard"}
                dateTime={
                  item?.lastRefreshed
                    ? convertDate(item?.lastRefreshed, false, true)
                    : "-"
                }
                iconWithDate={<RefreshIconBorderLess />}
                isLeftIconShouldRotate={sourceRefreshing === ind}
                onRefreshClick={() => refreshJobIntegrationApi(item, ind)}
              />
            ) : (
              <SourceCard
                index={ind}
                label={capitalizeFirstLetter(item?.provider)}
                email={item?.identifier ? item?.identifier : "-"}
                alias={item?.name ? capitalizeFirstLetter(item?.name) : "-"}
                icon={item?.icon}
                dateTime={
                  item?.lastRefreshed
                    ? convertDate(item?.lastRefreshed, false, true)
                    : "-"
                }
                SettingIcon={<SettingIcon />}
                DeleteIcon={<DeleteIcon />}
                iconWithDate={
                  !item?.isActive ? (
                    <WarningTriangle />
                  ) : (
                    <RefreshIconBorderLess />
                  )
                }
                onDeletePress={() => handleDeletePress(item, ind)}
                className={`${flippedIndex === ind ? "flipped" : ""}`}
                isLeftIconShouldRotate={sourceRefreshing === ind}
                deleteClicked={flippedIndex === ind}
                confirmationText={`${t("GENERAL.COMFIRMATION_REMOVE_SOURCE")}`}
                buttonNameLeft={t("GENERAL.YES")}
                buttonNameRight={t("GENERAL.NO")}
                onConfirmLeftButtonClick={() => setFlippedIndex(null)}
                onConfirmRightButtonClick={confirmDeleteSource}
                onRefreshClick={() => refreshJobIntegrationApi(item, ind)}
              />
            )}
          </div>
        );
      })}
      <CustomModal
        show={isOpenAddSource}
        isHeaderVisible={false}
        className="addSourceModal"
        size="lg"
        fullscreen="md-down"
        isFooterVisible={false}
      >
        <div className="addSourcePopup">
          <div className="addSourcePopupHeader">
            <div className="addSourcePopupHeaderTitle">
              <span>{t("RESUME.ADD_SOURCE")}</span>
            </div>
            <div
              className="crossButn"
              onClick={() => {
                setInQueryParams(
                  queryParams,
                  "isOpenAddSource",
                  false,
                  navigate,
                );
                setIsOpenAddSource(false);
                setAliasInputText("");
                setPrivacyCheck(false);
                setSelectedSource(null);
              }}
            >
              <CircleCrossIcon />
            </div>
          </div>
          <hr className="shortDivider" />
          <div className="addSourceList">
            {sourceData?.map((item: any) => {
              const isEvaluateDisabled =
                item.label === "Evluate" && isDataTypePresent;
              return (
                <div
                  title={capitalizeFirstLetter(item?.label)}
                  className={`iconSource ${selectedSource?.id === item.id ? "selected" : ""} ${isEvaluateDisabled ? "disabled" : ""}`}
                  key={item.id}
                  onClick={() => {
                    handleSourceClick(item);
                  }}
                >
                  <div className="iconSourceInner">
                    <img src={item?.icon} alt="Icon" />
                    <span>{item?.label}</span>
                  </div>
                  <div>
                    <SourceSelectTick
                      color={`${
                        selectedSource?.id === item.id
                          ? "var(--primary-green)"
                          : "var(--light-grey)"
                      }`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="addSourceButton">
            {selectedSource?.label !== JobScreensEnums.LABEL_EVLUATE && (
              <div className="aliasInput">
                <InputField
                  placeholder={t("GENERAL.GIVE_NAME_TO_SOURCE")}
                  onChange={(e: any) => setAliasInputText(e)}
                  value={aliasInputText}
                />
              </div>
            )}
            <div className="addsourceBtn">
              {selectedSource?.label !== JobScreensEnums.LABEL_EVLUATE && (
                <div className="privacyPolicyCheck">
                  <CheckboxRadio
                    type={"checkbox"}
                    checked={privacyCheck}
                    onChange={() => setPrivacyCheck(!privacyCheck)}
                    className="privacyCheckbox"
                  />
                  <span className="acceptPrivacyPolicy">
                    {t("GENERAL.ACCEPT")}&nbsp;
                  </span>
                  <span
                    className="acceptPrivacyPolicy link"
                    onClick={() =>
                      redirectTo("https://evluate.com/privacy-policy.php")
                    }
                  >
                    {t("GENEREAL.PRIVACY_POLICY")}
                  </span>
                </div>
              )}
              <AssessmentButton
                disabled={
                  addSourceLoading ||
                  selectedSource === null ||
                  (!aliasInputText &&
                    selectedSource?.label !== JobScreensEnums.LABEL_EVLUATE) ||
                  (selectedSource?.label !== JobScreensEnums.LABEL_EVLUATE &&
                    !privacyCheck)
                }
                onClick={() => handleAddSource()}
              >
                {addSourceLoading ? (
                  <div className="addSourceLoader">
                    <p>{t("GENERAL.PROCESSING")}</p>
                    <Loader />
                  </div>
                ) : (
                  t("RESUME.ADD_SOURCE")
                )}
              </AssessmentButton>
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
};
export default SourceList;
